export default __webpack_public_path__ + "static/media/poi_emergency.41a59148.svg";